/* eslint-disable func-names */
/* eslint-disable no-console */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-cond-assign */
import { AxiosRequestConfig } from "axios";
import { useState } from "react";
import { APIClientOptions, createAPIClient } from "../constants/apiClient";
import { ROOT_URL } from "../constants/urls";

const base_url = `${ROOT_URL}api`;

type AvosApiHook<T> = [
    (data?: any, extra_options?: any) => Promise<void>,
    T | null,
    any,
    any,
    (data?: any, extra_options?: any) => Promise<any>
];

const useAvosApi = <T = any>(
    endpoint: string,
    method = "GET",
    requestOptions: any = undefined,
    apiClientOptions: APIClientOptions | undefined = undefined
): AvosApiHook<T> => {
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);

    // configure the request
    const apiClient = createAPIClient(apiClientOptions);
    const callConfig = (data = {}, extra_options: any = {}) => apiClient({
        method,
        url: base_url + (extra_options.endpoint || endpoint),
        params: requestOptions,
        data,
        ...extra_options
    });


    // call the request, update state accordingly
    const call = (data = {}, extra_options = {}) => {
        setLoading(true);
        return callConfig(data, extra_options)
            .then((response) => setResponse(response.data))
            .catch((err) => {
                setError(err);
                console.log(err); // eslint-disable-line no-console
            })
            .finally(() => setLoading(false));
    };

    return [call, response, loading, error, callConfig];
};


export default useAvosApi;


export const callAvosApi = (endpoint, requestOptions?:AxiosRequestConfig, apiClientOptions?: APIClientOptions) => {
    const apiClient = createAPIClient(apiClientOptions);
    return apiClient({
        method: "GET",
        url: base_url + endpoint,
        ...requestOptions
    });
}; // assuming you use this too

export const streamAvosApi = async function* (endpoint, requestOptions?:AxiosRequestConfig, apiClientOptions?: APIClientOptions) {
    const apiClient = createAPIClient(apiClientOptions);
    const response = await apiClient({
        method: "GET",
        ...requestOptions,
        url: base_url + endpoint,
        adapter: "fetch", // 👈 Required for streaming
        responseType: "stream", // 👈 Required for streaming
    });

    if (!response.data) {
        throw new Error("Response body is null");
    }

    const reader = response.data.getReader();
    const decoder = new TextDecoder();

    const TIMEOUT_MS = requestOptions?.timeout || 600000;
    const startTime = Date.now();

    let buffer = ""; // Buffer to store incomplete chunks
    const parseChunk = function* (part: string) {
        if (part.trim()) {
            try {
                const parsed = JSON.parse(part.trim());
                yield parsed;
            } catch (error) {
                console.error("Failed to parse JSON chunk:", error, part.trim());
                throw new Error("Failed to parse JSON chunk");
            }
        }
    };
    while (Date.now() - startTime < TIMEOUT_MS) {
        // Read a chunk from the stream
        // eslint-disable-next-line no-await-in-loop
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk; // Append chunk to buffer

        // Split buffer into potential JSON objects
        const parts = buffer.split("\n");
        buffer = parts.pop() || ""; // Keep the last incomplete part in the buffer

        // eslint-disable-next-line no-restricted-syntax
        for (const part of parts) {
            yield* parseChunk(part);
        }
    }

    yield* parseChunk(buffer); // Yield any remaining data in the buffer

    // Check if the stream processing has exceeded the timeout
    // This is to prevent an infinite loop in case the stream never ends

    if (Date.now() - startTime >= TIMEOUT_MS) {
        console.error("Stream processing exceeded timeout, exiting to prevent infinite loop.");
        throw new Error("Stream processing exceeded timeout.");
    }
};

export const createAvosApiCall = (apiClientOptions?: APIClientOptions) => {
    const apiClient = createAPIClient(apiClientOptions);
    return (config: AxiosRequestConfig) => apiClient({
        ...config,
        url: base_url + config.url
    });
};
